import {Switch, Text, View} from "react-native";
import GlobalStyle from "../../../constants/GlobalStyle";
import {Controller, RegisterOptions} from "react-hook-form";
import * as React from "react";
import {useCoreForm} from "./CoreForm";

interface SwitchFieldControllerProps {
  rules?: RegisterOptions;
  controlName: string;
  title: string;
  required?: boolean;
}

export function SwitchFieldController({rules, controlName, title, required = false}: SwitchFieldControllerProps) {
  const {form: {control}} = useCoreForm();
  if (!control) return null;

  const extendedRules = {
    ...(rules ?? {}),
    required: required ? 'This field is required' : false
  };

  return (
    <Controller
      control={control}
      rules={extendedRules}
      name={controlName}
      render={({field: {onChange, value}, fieldState: {error}}) => (
        <View>
          <Text style={GlobalStyle.form__column__text}>{title}</Text>
          <Switch
            trackColor={{false: '#767577', true: '#81b0ff'}}
            thumbColor={value ? '#f5dd4b' : '#f4f3f4'}
            ios_backgroundColor="#3e3e3e"
            onValueChange={onChange}
            value={value}
          />
          {error && <Text style={{color: 'red'}}>{error.message}</Text>}
        </View>
      )}
    />
  )
}
